module.exports = __webpack_public_path__ + "img/wifi.b990ed38.svg";